import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import Button from '@mui/material/Button'
import styled from 'styled-components'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

interface Props {
  buttonText: string
  onClose: () => void
  open: boolean
  text: string | JSX.Element
  title: string
  width?: string
}

export default function SimpleDialog({ buttonText, open, onClose, text, title, width }: Props): JSX.Element {
  return (
    <StyledDialog open={open} onClose={onClose} width={width}>
      <StyledDialogContent>
        <IconButton aria-label="close" className="closeButton" onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <Title>{title}</Title>
        <ContentText>{text}</ContentText>
      </StyledDialogContent>
      <StyledDialogActions>
        <AcceptButton onClick={onClose}>{buttonText}</AcceptButton>
      </StyledDialogActions>
    </StyledDialog>
  )
}

const StyledDialog = styled(Dialog)<{ width?: string }>`
  .MuiDialog-paper {
    width: ${(props) => props.width || '500px'};
    position: relative;
  }

  .closeButton {
    position: absolute;
    right: 8px;
    top: 8px;
  }
`

const StyledDialogContent = styled(DialogContent)`
  padding: 64px 40px 0;

  &:first-child {
    padding-top: 64px;
  }
`

const StyledDialogActions = styled(DialogActions)`
  justify-content: flex-start;
  padding: 0 40px 40px;
`

const ContentText = styled(DialogContentText)`
  color: ${(props) => props.theme.customPalette.darkGreen};
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 40px;

  b {
    font-weight: 700;
  }
`

const Title = styled.h2`
  color: ${(props) => props.theme.customPalette.darkGreen};
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 20px;
`

const AcceptButton = styled(Button)`
  align-items: center;
  background: ${(props) => props.theme.palette.primary.main};
  color: ${(props) => props.theme.customPalette.light};
  display: flex;
  font-size: 16px;
  height: 53px;
  justify-content: center;
  margin-top: 6px;
  padding: 8px 24px;
  width: 200px;
`
